import { Suspense } from 'react';

import { ErrorBoundary } from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

import type { AddCoverProps } from './AddCover';

export function LazyAddCover({ cardId, navigateToSelectCover }: AddCoverProps) {
  const AddCover = useLazyComponent(
    () => import(/* webpackChunkName: "add-cover" */ './AddCover'),
    {
      preload: false,
      namedImport: 'AddCover',
    },
  );
  return (
    <Suspense fallback={null}>
      <ErrorBoundary
        tags={{
          ownershipArea: 'trello-web-eng',
          feature: 'Card Covers',
        }}
      >
        <AddCover
          cardId={cardId}
          navigateToSelectCover={navigateToSelectCover}
        />
      </ErrorBoundary>
    </Suspense>
  );
}
